import { i18n } from 'i18n-config';
import countries from 'i18n-iso-countries';
import { Option } from 'types/Option';

const countryUtil = async (locale: string) => {
  const countryCodes = Object.keys(countries.getAlpha2Codes());
  const { getName } = countries;

  const PRIORITY_CODES = [
    'NL',
    'CH',
    'DE',
    'AT',
    'IT',
    'FR',
    'ES',
    'GB',
    'US',
    'CN',
    'BE',
    'CA',
    'HK',
    'IE'
  ];

  for await (const localeIn of i18n.locales) {
    const langs = await import(`i18n-iso-countries/langs/${localeIn}.json`);
    countries.registerLocale(langs);
  }

  const codeToOption = (code: string) => ({ label: getName(code, locale), value: code });
  const sortByLocale = (a: Option, b: Option) => a.label?.localeCompare(b.label, locale);

  const priorityCountryOptions = PRIORITY_CODES.map(codeToOption).sort(sortByLocale);

  const countryOptions = countryCodes
    .filter((code) => !PRIORITY_CODES.includes(code))
    .map(codeToOption)
    .sort(sortByLocale);

  const result = [
    ...priorityCountryOptions,
    { label: '------------------------', value: '', disabled: true },
    ...countryOptions
  ] as Option[];

  return new Promise((resolve) => {
    if (
      countryOptions.every((option) => option.label && option.label) &&
      priorityCountryOptions.every((option) => option.label && option.label)
    )
      resolve(result);
  });
};

export default countryUtil;
